import { useRoute } from 'vue-router';
import { useApplicationStore } from '@/store/application';
import { storeToRefs } from 'pinia';
import logger from '@/core/logger/logger';

export default function useLoggable() {
    const {appReference} = storeToRefs(useApplicationStore());
    const route = useRoute();

    const info = (message: string, info: Record<string, unknown>) => {
        logger.info(message, {
            ref: appReference.value,
            route: route.name,
            country: route.params.country,
            ...info
        });
    };

    return { info };
}
